module.exports = __webpack_public_path__ + "static/media/icon-wallet.bcee709d.svg";